export enum RruleRepeatEnum {
  DAILY,
  DAILY_WEEKDAY,
  WEEKLY,
  MONTHLY,
  MONTHLY_WEEKDAY,
  MONTHLY_LAST_FRIDAY,
  MONTHLY_LAST_DAY,
  YEARLY,
  YEARLY_WEEKDAY,
  CUSTOM
}

export enum RruleFreqEnum {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export enum WeekCodeEnum {
  MO = 'MO',
  TU = 'TU',
  WE = 'WE',
  TH = 'TH',
  FR = 'FR',
  SA = 'SA',
  SU = 'SU'
}
